import PropTypes from 'prop-types';
import { useMemo } from 'react';
import stylesCommon from '../styles.module.scss';
import styles from './styles.module.scss';
import { size } from '@/helpers/lodash';
import OpensInNewTabIcon from '@/components/component-library/Icon/types/OpensInNewTab';
import Text from '@/components/component-library/Text';
import { classes } from '@/helpers/styling';
import Link from '@/components/component-library/Link';
import { getSupportedPlatforms } from '@/helpers/supported-platforms';

const LoadingTile = () => (
  <div className={classes(styles.tile, styles.isLoading)} />
);

const LoadingTiles = () => (
  <>
    <LoadingTile />
    <LoadingTile />
    <LoadingTile />
    <LoadingTile />
  </>
);

const ConnectTilesHorizontalStack = ({
  hideTitle,
  title,
  className,
  links,
  loading,
  alignLeft,
}) => {
  const supportedPlatforms = useMemo(
    () => getSupportedPlatforms({ links }).slice(0, 4),
    [links]
  );

  if (!size(links) || !size(supportedPlatforms)) {
    return null;
  }

  return (
    <div
      className={classes(
        stylesCommon.connectTiles,
        styles.connectTilesHorizontal,
        className,
        { [styles.alignLeft]: alignLeft }
      )}
    >
      {!hideTitle && (
        <Text bold className={styles.title} loading={loading} useHeaderFont>
          {title || 'Socials'}
        </Text>
      )}
      <div className={styles.tiles}>
        {loading ? (
          <LoadingTiles />
        ) : (
          supportedPlatforms
            .map(({ IconComponent, platform, patterns }) => {
              const externalLinkObject = links.find((l) =>
                (patterns || []).some((pattern) =>
                  new RegExp(pattern, 'g').test(l.url || '')
                )
              );

              if (!externalLinkObject) {
                return null;
              }

              const combinedTileClassName = classes(
                stylesCommon.tile,
                styles.tile,
                stylesCommon[platform]
              );

              return (
                <Link
                  className={classes(styles.tileContainer, {
                    [styles.alignLeft]: alignLeft,
                  })}
                  href={externalLinkObject.url}
                  key={platform}
                  openInNewTab
                >
                  {IconComponent ? (
                    <IconComponent className={combinedTileClassName} />
                  ) : (
                    <OpensInNewTabIcon
                      className={classes(
                        combinedTileClassName,
                        stylesCommon.defaultIcon
                      )}
                    />
                  )}
                </Link>
              );
            })
            .filter((_) => _)
            .slice(0, 4)
        )}
      </div>
    </div>
  );
};

ConnectTilesHorizontalStack.propTypes = {
  title: PropTypes.string,
  hideTitle: PropTypes.bool,
  className: PropTypes.string,
  links: PropTypes.array,
  loading: PropTypes.bool,
  alignLeft: PropTypes.bool,
};

ConnectTilesHorizontalStack.defaultProps = {
  title: '',
  hideTitle: false,
  className: '',
  links: [],
  loading: false,
  alignLeft: false,
};

export default ConnectTilesHorizontalStack;
